<template>
  <div class="talent-review">
    <AppBar />
    <div class="page-content">
      <div class="talent-review-canvas">
        <div class="talent-review-background">
          <img :src="top.imgBack" alt="" />
        </div>
        <div class="por-container">
          <div class="solution-info">
            <div class="solution-info-title">{{ top.title }}</div>
            <div class="solution-info-content" v-html="top.content">
              <!-- 利用在线招聘流程，帮助企业实现智能、便捷的招聘模式，
              建立企业自己的人才储备机制 -->
            </div>
          </div>
        </div>
      </div>
      <div ref="nav" class="talent-review-nav">
        <div ref="navTabs" class="talent-review-tabs" :style="{width: navWidth+'%', height: navHeight+'px'}">
          <div
            v-for="(item, index) in navList"
            :key="index"
            :class="['talent-review-nav-item', topNaviId === item.id ? 'top-nav-item' : '']"
            @click="goAnchor(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div>
        <div ref="pain-points" class="pain-points">
          <div class="title">企业痛点</div>
          <div class="pain-points-list">
            <div
              v-for="(item, index) in painPointsList"
              :key="index"
              class="pain-points-list-item"
              :style="{ background: 'url(' + item.backImg + ') no-repeat', }"
            >
              <div class="list-item-content">
                <div class="title" v-html="item.title"></div>
                <div class="describe">
                  {{ item.describe }}
                </div>
              </div>
              <div class="pain-points-btn" @click="openBealter">
                领取解决方案
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref="sense-of-worth">
        <div style="width: 100%; height: 60px; background-color: #fff;"></div>
        <div class="sense-of-worth">
          <div class="title">产品价值体现</div>
          <div class="sense-of-worth-content">
            <img :src="senseOfWorthImg" alt="" />
          </div>
        </div>
      </div>
      <div>
        <div ref="solution" class="solution">
          <div class="title">人才盘点解决方案</div>
          <div v-if="solutionContentList.length != 0" class="solution-content">
            <div class="solution-content-left">
              <div
                v-for="(item, index) in solutionContentList"
                :key="index"
                class="solution-content__tabInfo"
                :class="{'chack-tabInfo': index === solutionIndex}"
                @mouseenter="onMouseenter(index)"
              >
                <div class="solution-content__tabTitle">
                  <img v-if="index !== solutionIndex" :src="item.icon" alt="" />
                  <img v-else :src="item.checkIcon" alt="" />
                  <div>{{ item.title }}</div>
                </div>
                <div v-show="index === solutionIndex" class="solution-content__tabDesc">
                  {{ item.describe }}
                </div>
              </div>
            </div>
            <div class="solution-content-right">
              <transition name="tabImageWrap">
                <div
                  :key="solutionIndex"
                  class="solution-content__tabImage"
                  v-html="solutionContentList[solutionIndex].img"
                ></div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getColumnChild, getColumnDetail } from '@/api/column';
import { getContentList, getContentDetail } from '@/api/content';

export default {
  name: 'TalentReview',
  data () {
    return {
      top: {
        title: '',
        content: '',
        imgBack: require('@/assets/talentreview/canvas.gif'),
      },
      navWidth: 80,
      navHeight: 60,
      offsetTop: 0,
      scrollTop: 0,
      position: 0,
      topNaviId: null,
      navList: [
        {
          title: '企业痛点',
          id: 'pain-points',
        },
        {
          title: '产品价值观',
          id: 'sense-of-worth',
        },
        {
          title: '解决方案',
          id: 'solution',
        },
      ],
      painPointsList: [
        // {
        //   title: '<span style="color: #0f78da; font-weight: 600;">高成本</span>招聘外部关键人才',
        //   describe: '为应对市场变化，企业在转型升级的同时，需要专业型人才支持，通过外部招聘的方式往往需要投入大良时间和人力成本。',
        //   backImg: require('@/assets/talentreview/pain-points1.png'),
        // },
        // {
        //   title: '管理人员<span style="color: #0f78da; font-weight: 600;">流动率高</span>',
        //   describe: '没有好的人才激励方案和发展规划，导致管理人才流动频率高，对企业发展带来负面效果。',
        //   backImg: require('@/assets/talentreview/pain-points2.png'),
        // },
        // {
        //   title: '如何<span style="color: #0f78da; font-weight: 600;">有效发掘</span>内部人才',
        //   describe: '外部人才归属感不强，需要发掘内部稳定的潜在人才加以培养，更适合企业未来发展的要求',
        //   backImg: require('@/assets/talentreview/pain-points3.png'),
        // },
      ],
      senseOfWorthImg: '',
      solutionContentList: [
        // {
        //   icon: require('@/assets/talentreview/icon/tabInfo1.png'),
        //   checkIcon: require('@/assets/talentreview/icon/chack-tabInfo1.png'),
        //   title: '完善人才培养机制',
        //   describe: '树立“以人为本”的管理思想，塑造良好的人才培养环境，实施人性化管理，用关心和服务换取员工的主人翁意识和忠诚服务。',
        //   img: require('@/assets/talentreview/tabImage1.png'),
        // },
        // {
        //   icon: require('@/assets/talentreview/icon/tabInfo2.png'),
        //   checkIcon: require('@/assets/talentreview/icon/chack-tabInfo2.png'),
        //   title: '实施梯队人才培养模式',
        //   describe: '制定梯队人才培养实施计划，完善职业生涯发展通路，明确人才推荐、储备、培训、考核等制度，引导员工通过努力提升自己实现职业发展',
        //   img: require('@/assets/talentreview/tabImage2.png'),
        // },
        // {
        //   icon: require('@/assets/talentreview/icon/tabInfo3.png'),
        //   checkIcon: require('@/assets/talentreview/icon/chack-tabInfo3.png'),
        //   title: '建立激励机制',
        //   describe: '动态的为员工创造职业发展空间，以机制促进员工成长。根据其需求进行有效激励，同时必须对其进行有效的监督与制约。',
        //   img: require('@/assets/talentreview/tabImage3.png'),
        // },
      ],
      solutionIndex: 0,
    };
  },
  watch: {
    scrollTop(newValue, oldValue) {
      setTimeout(() => {
        if (newValue === window.scrollY) {
          for (var i = 0; i < this.navList.length; i++) {
            var elementTop = this.$refs[`${this.navList[i].id}`].offsetTop - this.scrollTop - 1;
            if (elementTop <= 70) {
              this.topNaviId = this.navList[i].id;
            }
          }
        }
      }, 20);
    },
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
    this.$nextTick(() => {
      const nav = this.$refs.nav;
      this.offsetTop = nav.offsetTop;
    });
    this.getPageColumn();
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      var offsetHeight = this.$refs.navTabs.offsetHeight;
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var headerFixed = this.scrollTop > this.offsetTop - offsetHeight / 2 - 70;
      var scroll = this.scrollTop - this.position;
      this.position = this.scrollTop;
      if (this.scrollTop <= 400) {
        this.navHeight = 52;
        this.navWidth = 80;
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (this.scrollTop >= 400 && !headerFixed) {
        this.navHeight += 0.04 * scroll;
        this.navWidth += 0.12 * scroll;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (headerFixed) {
        this.navHeight = 60;
        this.navWidth = 100;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'fixed';
        this.$refs.nav.style.top = offsetHeight / 2 + 70 + 'px';
      }
    },
    goAnchor(i) {
      // var id = '#' + i.id;
      // document.querySelector(id).scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start',
      // });
      window.scrollTo({
        top: this.$refs[`${i.id}`].offsetTop - 70,
        left: 0,
        behavior: 'smooth',
      });
    },

    // 获取页面栏目
    async getPageColumn() {
      const params = { parentId: '1607260661950406656', };
      getColumnChild(params).then(async (res) => {
        const { result, } = res;
        for (var i = 0; i < result.length; i++) {
          if (result[i].name === '企业痛点') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                const doc = new DOMParser().parseFromString(rtsult.defaultContent, 'text/html');
                var painPointsItem = {
                  title: doc.documentElement.textContent.replace(/&nbsp;/g, ' '),
                  describe: rtsult.description,
                  backImg: rtsult.icon,
                };
                this.painPointsList.push(painPointsItem);
              }
            });
          } else if (result[i].name === '产品价值观') {
            this.senseOfWorthImg = result[i].icon;
            // const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            // this.valueCenterImg = result[i].icon;
            // getContentList(data).then(async (rrs) => {
            //   const rrsult = rrs.result;
            //   for (var j = 0; j < rrsult.data.length; j++) {
            //     var valueAnalysisItem = {
            //       title: rrsult.data[j].title,
            //       icon: rrsult.data[j].icon,
            //       textList: [],
            //     };
            //     const rts = await getContentDetail(rrsult.data[j].id);
            //     const rtsult = rts.result;
            //     for (var x = 0; x < rtsult.elements.length; x++) {
            //       valueAnalysisItem.textList.push(rtsult.elements[x].content);
            //     }
            //     this.valueAnalysisList.push(valueAnalysisItem);
            //   }
            // });
          } else if (result[i].name === '解决方案') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var solutionItem = {
                  title: rrsult.data[j].title,
                  icon: rrsult.data[j].icon,
                  checkIcon: rrsult.data[j].logo,
                  describe: rrsult.data[j].description,
                  img: '',
                };
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                const doc = new DOMParser().parseFromString(rtsult.defaultContent, 'text/html');
                solutionItem.img = doc.documentElement.textContent.replace(/&nbsp;/g, ' ');
                this.solutionContentList.push(solutionItem);
              }
            });
          } else if (result[i].name === '顶部图') {
            getColumnDetail(result[i].id).then((rrs) => {
              const rrsult = rrs.result;
              var content = rrsult.elements.find(obj => obj.name === 'content').content;
              var contentdoc = new DOMParser().parseFromString(content, 'text/html');
              this.top.title = rrsult.elements.find(obj => obj.name === 'subtitle').content;
              this.top.content = contentdoc.documentElement.textContent.replace(/&nbsp;/g, ' ');
              // this.top = {
              //   imgBack: rrsult.icon,
              // };
            });
          }
        }
      });
    },

    onMouseenter(i) {
      this.solutionIndex = i;
    },
    openBealter () {
      this.$refs.altProduct.tobealter();
    },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  },
};
</script>

<style lang="less" scoped>
.talent-review{
  background-color: #fff;
  .page-content{
    width: 100%;
    .talent-review-canvas{
      width: 100%;
      height: fit-content;
      min-width: var(--minwidth);
      position: relative;
      background-size: cover;
      overflow: hidden;
      .talent-review-background{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-position: top;
        background-size: cover;
        background-repeat: no-repeat;
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center top;
        }
      }
      .por-container {
        width: 70%;
        max-width: 1200px;
        margin: 0 auto;
        position: relative;
        .solution-info {
          width: 480px;
          height: 560px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          box-sizing: border-box;
          .solution-info-title {
            font-size: 46px;
            font-weight: bold;
            line-height: 55px;
            color: #181818;
            margin-bottom: 29px;
          }
          .solution-info-content {
            font-size: 20px;
            line-height: 32px;
            color: #7b7b7b;
            margin-bottom: 44px;
          }
          // .solution-btn {
          //   width: 142px;
          //   height: 48px;
          //   background-color: #1589fd;
          //   color: #fff;
          //   text-align: center;
          //   line-height: 48px;
          //   cursor: pointer;
          //   border-radius: 24px;
          // }
        }
      }
    }
    .talent-review-nav{
      width: 100%;
      display: flex;
      position: relative;
      justify-content: center;
      z-index: 50;
      .talent-review-tabs{
        margin: 0 auto;
        box-shadow: 0px 2px 8px 0px rgba(139, 139, 139, 0.18);
        border-radius: 2px;
        background-color: #fff;
        display: flex;
        position: absolute;
        top: -26px;
        .talent-review-nav-item{
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #181818;
          font-size: 14px;
          cursor: pointer;
        }
        .talent-review-nav-item:hover{
          color: #00b0dc;
        }
        .top-nav-item {
          color: #fff;
          background-color: #00b0dc;
        }
        .top-nav-item:hover {
          color: #fff;
        }
      }
    }
    .pain-points{
      width: 1200px;
      padding-top: 115px;
      padding-bottom: 30px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        margin-bottom: 70px;
      }
      .pain-points-list{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .pain-points-list-item{
          width: 314px;
          height: 316px;
          padding: 40px 25px 50px 25px;
          border-radius: 4px;
          border-top: 4px solid #00b0dc;
          box-shadow: 0px 5px 20px 0px rgba(169, 176, 204, 0.2);
          box-sizing: border-box;
          background-size: cover;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-start;
          .list-item-content{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            .title{
              font-size: 20px;
              color: #323233;
              margin-bottom: 30px;
              .akey{
                font-size: 20px;
                color: #00b0dc;
                font-weight: 600;
              }
            }
            .describe{
              width: 100%;
              font-size: 16px;
              color: #323233;
              font-weight: 400;
              line-height: 24px;
              margin-bottom: 60;
            }
          }
          .pain-points-btn{
            width: 156px;
            height: 44px;
            background-color: #00b0dc;
            border-radius: 2px;
            font-size: 18px;
            font-weight: 300;
            text-align: center;
            line-height: 44px;
            color: #fff;
            cursor: pointer;
          }
        }
      }
    }
    .sense-of-worth{
      width: 100%;
      padding-top: 90px;
      padding-bottom: 70px;
      background-color: #f7f9fc;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        margin-bottom: 70px;
      }
      .sense-of-worth-content{
        width: 1200px;
        margin: 0 auto;
        img{
          width: 100%;
          height: auto;
          display: block;
        }
      }
    }
    .solution{
      width: 1200px;
      margin: 0 auto;
      padding-top: 90px;
      padding-bottom: 90px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      .title{
        font-size: 32px;
        color: #181818;
        margin-bottom: 70px;
      }
      .solution-content{
        width: 100%;
        min-height: 354px;
        display: flex;
        .solution-content-left{
          width: 590px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          .solution-content__tabInfo {
            width: 100%;
            height: 76px;
            min-height: 76px;
            padding: 29px 20px;
            box-sizing: border-box;
            border-radius: 8px;
            background-color: #fff;
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            overflow: hidden;
            transition: all .5s ease-in-out;
            .solution-content__tabTitle{
              width: 100%;
              display: flex;
              align-items: flex-start;
              font-size: 20px;
              line-height: 1;
              color: #181818;
              transition: all .5s ease-in-out;
              img{
                width: 20px;
                height: auto;
                margin-right: 14px;
                display: block;
                margin-top: 1px;
              }
            }
            .solution-content__tabDesc{
              width: 416px;
              margin-top: 16px;
              margin-left: 35px;
              font-size: 16px;
              color: #323233;
              opacity: 0;
              transition: all .5s ease-in-out;
            }
          }
          .chack-tabInfo{
            height: 158px;
            background-color: rgba(224, 235, 255, 0.4);
            .solution-content__tabTitle{
              color: #00b0dc;
            }
            .solution-content__tabDesc{
              opacity: 1;
            }
          }
        }
        .solution-content-right{
          margin-left: 40px;
          flex: 1;
          .solution-content__tabImage{
            height: 100%;
          }
          .tabImageWrap-enter-active{
            animation: bounce-in 0.5s;
          }
          .tabImageWrap-leave-active{
            animation: bounce-in 0s reverse;
          }
          @keyframes bounce-in {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
        }
      }
    }
  }
}
</style>
